
// Getter Object for AccountsRoyalty. Use it by calling mapGetters from the Vuex Host Components.

export const distributionAccountGetters = {
  accountDistributionData: (state) => state.accountDistributionData,
  accountList: (state) => state.accountList,
  accountListGPTContext: (state) => {
    return createLeanAccountList(state.accountList?.accounts);
  },
  distributionAccountDetails: (state) => state.distributionAccountDetails,
  distributionAccountDetailsGPTContext: (state) => {
    // state.distributionAccountDetails is [primary_key]: detail Object
    // Iterate all the Object keys and return the lean object
    // makeLeanSelectedAccountDetails();
    return Object.keys(state.distributionAccountDetails).reduce((acc, key) => {
      acc[key] = makeLeanSelectedAccountDetails(state.distributionAccountDetails[key]);
      return acc;
    });
  },
}

function createLeanAccountList(accounts) {
  return accounts.map(account => ({
    account_id: account.account_id,
    account_name: account.account_name,
    short_name: account.short_name,
    user_name: account.user_name,
    digital: account.digital,
    physical: account.physical,
    label_status_name: account.label_status_name,
    last_modified: account.last_modified
  }));
}


function makeLeanSelectedAccountDetails(data) {
  return {
    account: {
      account_name: data?.account?.account_name,
      account_type: data?.account?.account_type,
      physical: data?.account?.physical,
      currency_id: data?.account?.currency_id,
      short_name: data?.account?.short_name,
      notes: data?.account?.notes,
      contact_id_invoice: data?.account?.contact_id_invoice,
      main_account: data?.account?.main_account,
      own_stock: data?.account?.own_stock,
      no_backorder: data?.account?.no_backorder,
      ignore_payment_period: data?.account?.ignore_payment_period,
      mechanicals_omit: data?.account?.mechanicals_omit,
      default_order_type: data?.account?.default_order_type,
      pricelist_id: data?.account?.pricelist_id,
      price_list_discount: data?.account?.price_list_discount,
      shipping_info: data?.account?.shipping_info,
      deal_memo: data?.account?.deal_memo,
      release_shift: data?.account?.release_shift,
      status_id: data?.account?.status_id,
      digital: data?.account?.digital,
    },
    invoice_contact: {
      first_name: data?.invoice_contact?.first_name,
      last_name: data?.invoice_contact?.last_name,
      address1: data?.invoice_contact?.address1,
      postalcode: data?.invoice_contact?.postalcode,
      country: data?.invoice_contact?.country,
      phone1: data?.invoice_contact?.phone1,
      mobile1: data?.invoice_contact?.mobile1,
      email1: data?.invoice_contact?.email1,
    },
    delivery_contact: {
      company_name: data?.delivery_contact?.company_name,
      postalcode: data?.delivery_contact?.postalcode,
      country: data?.delivery_contact?.country,
      email1: data?.delivery_contact?.email1,
    },
    client: {
      default_currency: data?.client?.default_currency,
      display_name: data?.client?.display_name,
    },
    orders: data?.orders?.map(order => ({
      order_reference: order?.order_reference,
      status: order?.status,
      order_value: order?.order_value,
      account_id: order?.account_id,
      created: order?.created,
    })),
    backorders: data?.backorders?.map(backorder => ({
      release_title: backorder?.release_title,
      catalog_no: backorder?.catalog_no,
      format_name: backorder?.format_name,
      qty: backorder?.qty,
      backorder_id: backorder?.backorder_id,
      last_modified: backorder?.last_modified,
    })),
    invoices: data?.invoices?.map(invoice => ({
      invoice_id: invoice?.invoice_id,
      invoice_project_name: invoice?.invoice_project_name,
      due_days: invoice?.due_days,
      gross_amount_cc: invoice?.gross_amount_cc,
      name: invoice?.name,
      invoice_date: invoice?.invoice_date,
      last_name: invoice?.last_name,
      invoice_ref: invoice?.invoice_ref,
      color: invoice?.color,
      invoice_contact_email: invoice?.invoice_contact_email,
      first_name: invoice?.first_name,
    })),
    current_statements: data?.current_statements?.map(statement => ({
      period: statement?.period,
      year: statement?.year,
      type: statement?.type,
      currency: statement?.currency,
      income: statement?.income,
      difference: statement?.difference,
      total: statement?.total,
    })),
    statement_settings: data?.statement_settings?.map(setting => ({
      period: setting?.period,
      year: setting?.year,
      type: setting?.type,
      country: setting?.country,
      invoice: setting?.invoice,
      currency: setting?.currency,
      income: setting?.income,
      difference: setting?.difference,
      total: setting?.total,
    })),
    costs: data?.costs?.map(cost => ({
      creditor: cost?.creditor,
      date: cost?.date,
      cost_groups: cost?.cost_groups,
      description: cost?.description,
      net_amount: cost?.net_amount,
      status: cost?.status,
    })),
    price_lists: data?.price_lists?.map(priceList => ({
      price_list_id: priceList?.price_list_id,
      price_list_name: priceList?.price_list_name,
    })),
    label_accounts: data?.label_accounts?.map(labelAccount => ({
      label_account_id: labelAccount?.label_account_id,
      account_id: labelAccount?.account_id,
      short_name: labelAccount?.short_name,
    })),
    product_accounts: data?.product_accounts?.map(productAccount => ({
      product_account_id: productAccount?.product_account_id,
      catalog_no: productAccount?.catalog_no,
      release_title: productAccount?.release_title,
    })),
  };
}
